module.exports = __webpack_public_path__ + "img/cases-brand-hpnk-2.1f242d1d.jpg";